import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import http from "./http";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './commen.less'
import './assets/font/font.less';
import './assets/icon/icon.css'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);


Vue.prototype.$api = http;
Vue.$httpRequestList = [];
Vue.use(Antd);
Vue.config.productionTip = false;
Vue.prototype.$jumpTo=(path,query={})=>{
  router.push({path,query})
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
